import React from 'react';
import { PAGE_ROUTE } from '../../lib/routes';
import { Logo } from './Logo';
interface FooterProps {
  navigate: (page: string) => void;
}
export function Footer({
  navigate
}: FooterProps) {
  const currentYear = new Date().getFullYear();
  return <footer className="border-t border-dark-4 bg-dark-1" data-id="element-2153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2154">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-2155">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-2156">
            <button onClick={() => navigate(PAGE_ROUTE.HOME)} className="flex items-center gap-2 cursor-pointer" aria-label="Izio" data-id="element-2157">
              <Logo className="h-7 w-auto" data-id="element-2158" />
            </button>
            <p className="text-sm text-light-3 mt-3 max-w-xs" data-id="element-2159">
              Platforma unde chiriile aplică la chiriași. Inversăm procesul de
              închiriere.
            </p>
          </div>

          {/* Platform */}
          <div data-id="element-2160">
            <h4 className="font-semibold text-sm text-light-1 mb-4" data-id="element-2161">
              Platformă
            </h4>
            <ul className="space-y-2.5" data-id="element-2162">
              <li data-id="element-2163">
                <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2164">
                  Marketplace
                </button>
              </li>
              <li data-id="element-2165">
                <button onClick={() => navigate(PAGE_ROUTE.ONBOARDING)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2166">
                  Creează profil
                </button>
              </li>
              <li data-id="element-2167">
                <button onClick={() => navigate(PAGE_ROUTE.DASHBOARD)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2168">
                  Autentificare
                </button>
              </li>
              <li data-id="element-2169">
                <button onClick={() => navigate(PAGE_ROUTE.TEASING)} className="text-sm text-light-1 hover:text-lime-1 transition-colors cursor-pointer inline-flex items-center gap-1.5 font-medium" data-id="element-2170">
                  Beta
                  <span className="bg-lime-1 text-dark-1 text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-2171">
                    NEW
                  </span>
                </button>
              </li>
            </ul>
          </div>

          {/* For Landlords */}
          <div data-id="element-2172">
            <h4 className="font-semibold text-sm text-light-1 mb-4" data-id="element-2173">
              Pentru proprietari
            </h4>
            <ul className="space-y-2.5" data-id="element-2174">
              <li data-id="element-2175">
                <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2176">
                  Caută chiriași
                </button>
              </li>
              <li data-id="element-2177">
                <span className="text-sm text-light-4" data-id="element-2178">Cum funcționează</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-2179">
            <h4 className="font-semibold text-sm text-light-1 mb-4" data-id="element-2180">Legal</h4>
            <ul className="space-y-2.5" data-id="element-2181">
              <li data-id="element-2182">
                <button onClick={() => navigate(PAGE_ROUTE.TERMENI)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2183">
                  Termeni si conditii
                </button>
              </li>
              <li data-id="element-2184">
                <button onClick={() => navigate(PAGE_ROUTE.CONFIDENTIALITATE)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2185">
                  Politica de confidentialitate
                </button>
              </li>
              <li data-id="element-2186">
                <button onClick={() => navigate(PAGE_ROUTE.CONTACT)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2187">
                  Contact
                </button>
              </li>
              <li data-id="element-2188">
                <button className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-preferences'))} data-id="element-2189">
                  Setări cookie-uri
                </button>
              </li>
              <li data-id="element-2190">
                <button onClick={() => navigate(PAGE_ROUTE.CHANGELOG)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer inline-flex items-center gap-1.5" data-id="element-2191">
                  Changelog
                  <span className="text-[10px] font-mono text-light-4 border border-dark-4 px-1 py-0.5 rounded" data-id="element-2192">
                    v132
                  </span>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-dark-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-2193">
          <p className="text-sm text-light-4" data-id="element-2194">
            © {currentYear} Izio. Toate drepturile rezervate.
          </p>
          <div className="flex items-center gap-4" data-id="element-2195">
            <span className="text-xs text-light-4" data-id="element-2196">Făcut cu ❤️ în România</span>
          </div>
        </div>
      </div>
    </footer>;
}